import { render } from "./addMaketing.vue?vue&type=template&id=e955b7ae&scoped=true"
import script from "./addMaketing.vue?vue&type=script&lang=js"
export * from "./addMaketing.vue?vue&type=script&lang=js"

import "./addMaketing.vue?vue&type=style&index=0&id=e955b7ae&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e955b7ae"]])

export default __exports__